import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/pvsa/form-attachments"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const formAttachmentsApi = createApi({
    reducerPath: "formAttachmentsApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: ['FormAttachments'],
    endpoints: (builder) => ({
        getElementAttachments: builder.query({
            query: (params) => {
                const tmp = new URLSearchParams();
                tmp.append('element-id', params.elementId);
                tmp.append('movement-id', params.movementId);
                if (params.ccId) {
                    tmp.append('cc-id', params.ccId);
                }
                return `/?${tmp.toString()}`;
            },
            transformResponse: (response) => response.data,
            providesTags: ['FormAttachments']
        }),
        createElementAttachment: builder.mutation({
            query: (obj) => ({
                url: `/`,
                method: "POST",
                body: obj,
            }),
            invalidatesTags: ["FormAttachments"],
        }),
        deleteElementAttachment: builder.mutation({
            query: (id) => ({
                url: `/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["FormAttachments"],
        }),
        getUploadedAttachments: builder.query({
            query: ({ movementId, exceptIds }) => `/get-already-uploaded?movement-id=${movementId}&except-ids=${exceptIds}`,
            transformResponse: (response) => response.data,
        }),
        selectElementAttachment: builder.mutation({
            query: (obj) => ({
                url: `/0`,
                method: "PUT",
                body: obj,
            }),
            invalidatesTags: ["FormAttachments"],
        }), 
    }),
});

export const {
    useGetElementAttachmentsQuery,
    useLazyGetElementAttachmentsQuery,
    useCreateElementAttachmentMutation,
    useDeleteElementAttachmentMutation,
    useLazyGetUploadedAttachmentsQuery,
    useSelectElementAttachmentMutation,
} = formAttachmentsApi;
